export class RRBreadcrumbModel {
  url: string;
  label: string;
  active?: boolean;
  tooltip?: string;
}
